import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "@app/services/auth/auth.service";
import { SuperAdminService } from "@app/services/super-admin/super-admin.service";

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private router: Router,
    private superAdmin: SuperAdminService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has("skipInterceptor")) {
      const headers = req.headers.delete("skipInterceptor");
      return next.handle(req.clone({ headers }));
    }

    if (this.auth.isAuthenticated()) {
      const request = req.clone({
        setHeaders: {
          Accept: "application/json",
          Authorization: `Bearer ${this.auth.getToken()}`,
        },
      });

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // A 401 during an impersonation means that session ran out its 30 minutes. The
            // Super Admin behind it is still signed in, so hand their own token back instead
            // of logging them out.
            if (this.superAdmin.isImpersonating) {
              this.superAdmin.restoreImpersonatorSession();
              window.location.href = "/admin/users";
              return throwError(() => error);
            }

            this.auth.deleteToken();
            this.router.navigate(["/login"]);
          } else if (error.status === 423)
            this.router.navigate(["/settings/subscription"]);

          return throwError(() => error);
        })
      );
    }
    return next.handle(req);
  }
}
